module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contain"
  }, [_c('div', {
    staticClass: "posting-uploader"
  }, [_vm._l((_vm.postData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "posting-uploader-item"
    }, [_c('img', {
      staticClass: "imgPreview",
      attrs: {
        "src": item.url,
        "alt": "图片"
      },
      on: {
        "click": function($event) {
          return _vm.imagePreview(index)
        }
      }
    }), _vm._v(" "), _c('van-icon', {
      staticClass: "delte",
      attrs: {
        "name": "close"
      },
      on: {
        "click": function($event) {
          return _vm.delImg(index)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('van-uploader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postData.length < _vm.limit),
      expression: " postData.length < limit"
    }],
    attrs: {
      "after-read": _vm.uploadFile,
      "multiple": "",
      "accept": "image/*",
      "result-type": "text",
      "upload-text": "上传图片"
    }
  })], 2), _vm._v(" "), _c('van-popup', {
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  }, [_c('div', {
    staticClass: "circle-div"
  }, [_c('van-circle', {
    attrs: {
      "stroke-width": 60,
      "color": {
        '0%': '#ffad19',
        '100%': '#fec835',
      },
      "rate": _vm.progress,
      "speed": 100,
      "text": _vm.progress + '%'
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  })], 1), _vm._v(" "), _c('div', [_c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin-top": "10px"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "native-type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v("取消上传")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef0fe276","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picker/PicUploader2.vue
// module id = 2632
// module chunks = 0